import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { GroupIdDto } from '../../dto/GroupIdDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiAddQrCode = async (dto?: GroupIdDto) => {
  const params: IApiParams = {
    url: '/bat-qr-code/addBarQrCode.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
